// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"b2280156","488":"cf3b5ffa"}[chunkId] + ".chunk.js";
};